module.exports = __webpack_public_path__ + "static/media/SP_C_Embroidery_Accademia_White_3955_3377_3364.a279dbd2.png";